import { ChangeEvent, FC } from 'react';
import { useTranslation } from 'react-i18next';

import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { clsx } from 'clsx';
import { useBreakpoints } from 'hooks';

import { ISwitchProps } from './types';

import styles from './Switch.module.scss';

import scssVariables from 'styles/sass-variables.module.scss';

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 40,
  height: 24,
  padding: 0,
  display: 'flex',
  borderRadius: 12,
  margin: '0 16px',
  border: `1px solid ${scssVariables.primary_purple_default}`,
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    color: scssVariables.primary_purple_default,
    margin: 3,
    padding: 0,
    '&.Mui-checked': {
      transform: 'translateX(15px)',
      color: scssVariables.primary_purple_default,
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: scssVariables.page_background,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 16,
    height: 16,
    borderRadius: 12,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 24 / 2,
    opacity: 1,
    backgroundColor: scssVariables.page_background,
    boxSizing: 'border-box',
  },
}));

export const CustomizedSwitches: FC<ISwitchProps> = ({ switcherValue, onChange }) => {
  const { t } = useTranslation();
  const { isMobile } = useBreakpoints();

  const handleSwitchChange = ({ target: { checked } }: ChangeEvent<HTMLInputElement>) => onChange(checked);

  return (
    <Stack direction="row" alignItems="center" className={styles.switchWrapper}>
      <Typography
        className={clsx(styles.switchLabel, {
          [styles.boldLabel]: !switcherValue,
        })}
      >
        {t('billMonthly')}
      </Typography>
      <CustomSwitch onChange={handleSwitchChange} />
      <Typography
        className={clsx(styles.switchLabel, {
          [styles.boldLabel]: switcherValue,
          [styles.mobileLabel]: isMobile,
        })}
      >
        {t('billYearly')}
        <Typography component="span" className={styles.discountLabel}>
          {t('saveThirty')}
        </Typography>
      </Typography>
    </Stack>
  );
};
